import React from "react";
import {
  Col,
  Form,
  IFormValues,
  Input,
  required,
  Row,
  Spin,
  Switch,
  TextArea,
} from "@xala/common-ui";
import { useTranslation } from "react-i18next";
import { ILanguageModel } from "@xala/common-services";

export interface IDictionaryLanguageFormProps {
  language: ILanguageModel;
  isProcessing: boolean;
  updateLanguage: (language: ILanguageModel) => void;
  insertLanguage: (language: ILanguageModel) => void;
}

export const DictionaryLanguageForm: React.FC<IDictionaryLanguageFormProps> = (
  props
) => {
  const { language, insertLanguage, updateLanguage, isProcessing } = props;
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const isNewLanguage = language.Id < 0;

  const onFinish = async (values: IFormValues) => {
    const data: ILanguageModel = {
      ...language,
      ...values,
      Sequence: parseInt(values.Sequence, 10),
    };

    if (isNewLanguage) {
      delete data.Sequence;

      insertLanguage(data);
    } else {
      updateLanguage(data);
    }
  };

  const renderSequenceField = () => {
    if (!isNewLanguage) {
      return (
        <Form.Item
          name="Sequence"
          label={t("Sequence", "Sequence")}
          rules={[required()]}
        >
          <Input placeholder={t("Sequence", "Sequence")} />
        </Form.Item>
      );
    }
  };

  return (
    <Spin spinning={isProcessing}>
      <Form
        name="DictionaryLanguageForm"
        className="DictionaryLanguageForm"
        form={form}
        initialValues={{ ...language, Sequence: `${language.Sequence}` }}
        onFinish={onFinish}
        layout="vertical"
      >
        <Row direction="column" justify="space-between" className="full-height">
          <Col>
            <Form.Item
              name="Code"
              label={t("Code", "Code")}
              rules={[required()]}
            >
              <Input placeholder={t("Code", "Code")} />
            </Form.Item>

            <Form.Item
              name="Name"
              label={t("Name", "Name")}
              rules={[required()]}
            >
              <Input placeholder={t("Name", "Name")} />
            </Form.Item>

            <Form.Item
              name="Description"
              label={t("Description", "Description")}
            >
              <TextArea
                placeholder={t("Description", "Description")}
                autoSize={{ minRows: 4 }}
              />
            </Form.Item>

            {renderSequenceField()}

            <Form.Item>
              <Row gutter={8}>
                <Col>
                  <Form.Item name="UpToDate" valuePropName="checked">
                    <Switch />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="UpToDate">
                    <label>{t("UpToDate", "Up to date")}</label>
                  </Form.Item>
                </Col>
              </Row>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};
